import React from 'react'

export const SessionContext = React.createContext()

export const SiteDataContext = React.createContext()
